import { useContext } from 'react';
import { SignupFormDataContext } from '../forms/SignupCardV2/SignupFormDataContext';
import { isFeatureEnabled } from '../../../utils/configurations';
import { FeatureFlag } from '@signup/shared';

const GDPR_COUNTRY_ISO_CODES: string[] = ['CY', 'GR', 'DE', 'IT', 'LT', 'NO', 'PL'];

// Asia pacific region country codes
const APJ_COUNTRY_ISO_CODES: string[] = [
  'AU',
  'NZ',
  'IN',
  'SG',
  'PH',
  'TH',
  'MY',
  'ID',
  'KR',
  'JP',
  'PK',
  'LK',
  'NP',
  'CN',
  'HK',
  'TW',
  'BD',
  'UZ',
  'KZ',
  'MN',
  'KH',
  'PG',
  'BT',
  'WS',
  'MV',
  'NC',
  'FJ',
  'TO',
];

export const isCountryISOCodeInAPJ = (countryISOCode: string): boolean => {
  return APJ_COUNTRY_ISO_CODES.includes(countryISOCode);
};

export const isCountryISOCodeInGDPR = (countryISOCode: string): boolean => {
  return GDPR_COUNTRY_ISO_CODES.includes(countryISOCode);
};

export const isCountryISOCodeInUS = (countryISOCode: string): boolean => {
  return countryISOCode == 'US';
};

// Countries that require an explicit opt-in for marketing emails (B2B compliance)
const OPT_IN_COUNTRY_ISO_CODES: string[] = [
  'AT', // Austria
  'CZ', // Czech Republic
  'DE', // Germany
  'GR', // Greece
  'IT', // Italy
  'LU', // Luxembourg
  'NO', // Norway
  'CH', // Switzerland
  'AE', // United Arab Emirates
  'AU', // Australia
  'BE', // Belgium
  'BM', // Bermuda
  'CA', // Canada
  'CL', // Chile
  'CN', // China
  'CO', // Colombia
  'CY', // Cyprus
  'DK', // Denmark
  'FR', // France
  'IL', // Israel
  'JP', // Japan
  'KR', // Korea (South Korea)
  'LV', // Latvia
  'LT', // Lithuania
  'MT', // Malta
  'NL', // Netherlands
  'NZ', // New Zealand
  'PH', // Philippines
  'PL', // Poland
  'PT', // Portugal
  'RO', // Romania
  'SA', // Saudi Arabia
  'SK', // Slovakia
  'ZA', // South Africa
  'ES', // Spain
  'LK', // Sri Lanka
  'TH', // Thailand
  'VN', // Viet Nam
];

export const isCountryISOCodeOptIn = (countryISOCode: string): boolean => {
  return OPT_IN_COUNTRY_ISO_CODES.includes(countryISOCode);
};

export function useIsPhoneNumberRequired(): boolean {
  const { countryIsoCode } = useContext(SignupFormDataContext)!;

  return countryIsoCode === 'JP' && isFeatureEnabled(FeatureFlag.FF_ENABLE_JAPAN_PHONE_NUMBER);
}
